import { PropsWithChildren } from 'react';
import {
  StatusError,
  StatusOK,
  StatusPending,
  StatusWarning,
} from '@backstage/core-components';
import { RegistryStatus } from './api';

const STATUS_LABELS: Record<RegistryStatus, string> = {
  approved: 'Approved',
  hold: 'Hold',
  deprecated: 'Deprecated',
};

export const statusLabel = (status?: RegistryStatus) =>
  status ? STATUS_LABELS[status] : 'Unreviewed';

/** The registry status as an icon and label; children replace the label. */
export const PackageStatus = ({
  status,
  children,
}: PropsWithChildren<{ status?: RegistryStatus }>) => {
  switch (status) {
    case 'approved':
      return <StatusOK>{children ?? statusLabel(status)}</StatusOK>;
    case 'hold':
      return <StatusWarning>{children ?? statusLabel(status)}</StatusWarning>;
    case 'deprecated':
      return <StatusError>{children ?? statusLabel(status)}</StatusError>;
    default:
      return <StatusPending>{children ?? statusLabel(status)}</StatusPending>;
  }
};
